const RenderError = ({ error }) => {
  return (
    <div className="text-danger" hidden={!error}>{error}</div>
  )
}

export default RenderError
